module.exports = __webpack_public_path__ + "img/ATT_FAQ02.72d3e680.jpg";